<template>
  <Layout>
    <app-recibos-tabla />
  </Layout>
</template>

<script>
import RecibosTabla from "../components/RecibosTabla/RecibosTabla.vue";

export default {
  components: {
    "app-recibos-tabla": RecibosTabla
  }
};
</script>
